import { Injectable } from '@angular/core';
import { SQLiteObject } from '@ionic-native/sqlite';

@Injectable()
export class SqlStorageProvider {

  db: SQLiteObject = null;

  constructor() {
    
  }

  setDatabase(db: SQLiteObject) {
    if (this.db === null) {
      this.db = db;
    }
  }

  createTableProdutos() {
    let sql = 'CREATE TABLE IF NOT EXISTS produtos(produto_id INTEGER, produto_nome VARCHAR(150), produto_imagem VARCHAR(255))';
    return this.db.executeSql(sql, []);
  }

  /*
  adicionarProdutos(produtos) {
    for (var produto of produtos) {
      let sql = 'INSERT INTO produtos(produto_id, produto_categoria, produto_nome, produto_imagem) VALUES(?,?,?,?)';
      this.db.executeSql(sql, [produto.produto_id, produto.produto_categoria_id, produto.produto_nome, produto.produto_imagem]);
    }
  }*/

  selectProduto(produto_id) {
    let sql = 'SELECT * FROM produtos WHERE produto_id = ?';
    return this.db.executeSql(sql, [produto_id]).then(data => {
      let produto = [];
      for (let index = 0; index < data.rows.length; index++) {
        produto.push(data.rows.item(index));
      }
      return Promise.resolve(produto);
    });
  }

  adicionaProduto(produto_id, produto_nome, produto_imagem) {
    let sql = 'INSERT INTO produtos(produto_id, produto_nome, produto_imagem) VALUES (?,?,?)';
    return this.db.executeSql(sql, [produto_id, produto_nome, produto_imagem]);
  }

  getProdutos() {
    let sql = 'SELECT * FROM produtos';
    return this.db.executeSql(sql, []).then(data => {
      let produtos = [];
      for (let index = 0; index < data.rows.length; index++) {
        produtos.push(data.rows.item(index));
      }
      return Promise.resolve(produtos);
    });
  }

  removeProduto(produto_id) {
    let sql = 'DELETE FROM produtos WHERE produto_id = ?';
    return this.db.executeSql(sql, [produto_id]);
  }

  /*
  update(task: any) {
    let sql = 'UPDATE tasks SET title=?, completed=? WHERE id=?';
    return this.db.executeSql(sql, [task.title, task.completed, task.id]);
  }*/


}



// WEBPACK FOOTER //
// ./src/providers/sql-storage.ts